import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api, fmt2 } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle } from "lucide-react";

export default function BookingConfirmation() {
  const { groupId } = useParams();
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/bookings");
        setBookings((r.data || []).filter((b) => b.booking_group_id === groupId));
      } catch (e) { /* ignore */ }
    })();
  }, [groupId]);

  const total = bookings.reduce((s, b) => s + (b.line_final || 0), 0);

  return (
    <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-10 py-12" data-testid="booking-confirmation-page">
      <div className="rounded-3xl bg-card border border-border p-8 text-center">
        <CheckCircle className="h-12 w-12 text-emerald-600 mx-auto" />
        <h1 className="mt-4 font-display text-3xl font-semibold tracking-tight">Booking confirmed!</h1>
        <p className="text-muted-foreground mt-1">Confirmation ID: <span className="font-mono">{groupId}</span></p>

        <div className="mt-6 grid gap-3 text-left">
          {bookings.map((b) => (
            <div key={b.booking_id} className="rounded-2xl bg-background border border-border p-4 flex items-center gap-3">
              {b.image && <img src={b.image} alt="" className="h-14 w-20 object-cover rounded-lg" />}
              <div className="flex-1">
                <div className="font-semibold">{b.title}</div>
                <div className="text-xs text-muted-foreground">Date: {b.date} · Guests: {b.guests}</div>
              </div>
              <div className="font-semibold">{fmt2(b.line_final)}</div>
            </div>
          ))}
        </div>

        <div className="mt-5 text-sm">Total charged: <span className="font-semibold">{fmt2(total)}</span></div>

        <div className="mt-6 flex flex-wrap justify-center gap-2">
          <Link to="/dashboard"><Button className="rounded-xl" data-testid="confirmation-view-trips-button">View my trips</Button></Link>
          <Link to="/"><Button variant="ghost" className="rounded-xl">Keep exploring</Button></Link>
        </div>
      </div>
    </div>
  );
}
